import { LuFileText } from 'react-icons/lu';
import Button from '../../component/button/button';
import { HiOutlineUpload } from 'react-icons/hi';
import './Questions.style.scss';
import FIlter from './Fillter';
import { useEffect, useState } from 'react';
import QuestionList from './QuestionList';
import Header from '../../component/header/header';
import BulkQuestionUpload from '../BulkQuestionUpload/BulkQuestionUpload';
import toast from 'react-hot-toast';
import { FiCheckCircle } from 'react-icons/fi';
import { getAllQuestion } from '../../api/question';
import { DEFAULT_QUESTION_LIST_FILTER, QuestionListFilter, TQuestion } from '../../api/type';
import { useNavigate, useSearchParams } from 'react-router';

const Questions = () => {
  const [questions, setQuestions] = useState<{
    data: TQuestion[]
    totalPage: number
  }>({
    data: [],
    totalPage: 0,
  });

  const [isQuestionModelOpen, setIsQuestionModelOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [filter, setFilter] = useState<QuestionListFilter>({
    ...DEFAULT_QUESTION_LIST_FILTER,
  });

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const notify = () =>
    toast.success(
      'Your question has been uploaded. We will notify you once it is available for preview.',
      {
        icon: <FiCheckCircle color={'var(--success-600)'} size={58} />,
      }
    );

  useEffect(() => {
    const nextFilter: QuestionListFilter = {
      ...DEFAULT_QUESTION_LIST_FILTER,
      generation_job_id: searchParams.get('generation_job_id') || '',
      verification_status: searchParams.get('verification_status') || '',
      bulk_session_id: searchParams.get('bulk_session_id') || '',
    };
    setFilter(nextFilter);
    getQuestion(nextFilter);
  }, [searchParams]);

  const getQuestion = (
    nextFilter: Partial<QuestionListFilter> = {},
    isPagination?: boolean
  ) => {
    if (isPagination) {
      setIsLoadingMore(true);
    } else {
      setIsLoading(true);
    }

    getAllQuestion(nextFilter)
      .then(res => {
        const { data, pagination } = res?.data;
        setQuestions(prev => ({
          data: isPagination ? [...prev.data, ...data] : data,
          totalPage: pagination.total_pages,
        }));
      })
      .catch(error => {
        console.log({ error }, 'this is data error');
      })
      .finally(() => {
        if (isPagination) {
          setIsLoadingMore(false);
        } else {
          setIsLoading(false);
        }
      });
  };

  const applyFilter = () => {
    const nextFilter = { ...filter, page_number: 1 };
    setFilter(nextFilter);
    setQuestions({
      data: [],
      totalPage: 0,
    });
    getQuestion(nextFilter);
  };
  const clearFilter = () => {
    setFilter({ ...DEFAULT_QUESTION_LIST_FILTER });
    setQuestions({
      data: [],
      totalPage: 0,
    });
    getQuestion({ ...DEFAULT_QUESTION_LIST_FILTER });
  };

  const removeQuestion = (id: string) => {
    setQuestions((prev) => ({
      ...prev,
      data: prev.data.filter((question) => question.id !== id),
    }));
  };

  const updateQuestion = (id: string, patch: Partial<TQuestion>) => {
    setQuestions((prev) => ({
      ...prev,
      data: prev.data.map((question) =>
        question.id === id ? { ...question, ...patch } : question
      ),
    }));
  };

  return (
    <div className="content question">
      <Header
        pageTitle="Question"
        buttonText="Create Question"
        para={
          <span>
            <p>Welcome to the Question Management Page!</p>
            <p>
              Create or upload questions with ease and explore the complete list
              of available questions.
            </p>
          </span>
        }
        extraButton={
          <Button
            text="Upload bulk questions"
            type="secondary"
            icon={<HiOutlineUpload size={22} />}
            onClick={() => setIsQuestionModelOpen(true)}
          />
        }
        onClick={() => navigate('/questions/create-question')}
      />

      {/* <Button text='click me' onClick={notify} /> */}
      <div className="question__layout">
        <FIlter
          filter={filter}
          setFilter={setFilter}
          applyFilter={applyFilter}
          clearFilter={clearFilter}
        />
        {questions?.data && (
          <QuestionList
            loading={isLoading}
            isLoadingMore={isLoadingMore}
            data={questions?.data}
            totalPage={questions.totalPage}
            filter={filter}
            setFilter={setFilter}
            getQuestion={getQuestion}
            onRemoveQuestion={removeQuestion}
            onUpdateQuestion={updateQuestion}
          />
        )}
      </div>

      <BulkQuestionUpload
        closeModal={() => setIsQuestionModelOpen(prev => !prev)}
        isOpen={isQuestionModelOpen}
        notify={notify}
      />
    </div>
  );
};

export default Questions;
